import { render, staticRenderFns } from "./ShippingForm.vue?vue&type=template&id=39111c2b"
import script from "./ShippingForm.vue?vue&type=script&lang=js"
export * from "./ShippingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports